import React, {
	forwardRef,
	useState,
	useEffect,
	useImperativeHandle,
	Ref,
} from 'react';
import cx from 'classnames';

import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
export type GdprCategoryProps = {
	cat: object;
	handleChange: Function;
} & ThemeProps;

/**
 * COMPONENT
 */
export const GdprCategory = forwardRef(
	({ cat, handleChange, theme = {} }: GdprCategoryProps, ref: Ref<{}>) => {
		const [isCollapsed, setIsCollapsed] = useState(true);
		const [isEnabled, setIsEnabled] = useState(cat['enabled']);

		useEffect(() => {
			handleChange({
				enabled: isEnabled,
				id: cat['id'],
			});
		}, [isEnabled]);

		// Allows to call these functions from the parent
		useImperativeHandle(ref, () => ({
			getId,
			setEnabled,
		}));

		// ##############################
		// #region Event handler
		// ##############################

		const onToggle = (event) => {
			event.stopPropagation();

			setIsCollapsed(!isCollapsed);
		};

		const onChange = (event) => {
			event.stopPropagation();

			setIsEnabled(event.target.checked);
		};

		const stopPropagation = (event) => {
			event.stopPropagation();
		};

		// ##############################
		// #endregion
		// ##############################

		const getId = () => {
			return cat['id'];
		};

		const setEnabled = (enabled = false) => {
			if (cat['mandatory']) return;
			setIsEnabled(enabled);
		};

		const rootClass = cx(
			'supt-gdprCategory',
			getStyles(theme),
			!isCollapsed && 'supt-isExpanded'
		);

		return (
			<li className={rootClass}>
				<div className="supt-gdprCategory__tab" onClick={onToggle}>
					<button className="supt-gdprCategory__title">
						<span>{cat['title']}</span>
					</button>
					{cat['mandatory'] ? (
						<span className="supt-gdprCategory__caption">
							{cat['texts']?.['alwaysEnabled']}
						</span>
					) : (
						<div
							className="supt-gdprCategory__switch"
							onClick={stopPropagation}
						>
							<input
								type="checkbox"
								className="supt-gdprCategory__checkbox"
								id={`cookie-law-category-checkbox-${cat['id']}`}
								checked={isEnabled}
								onChange={onChange}
							/>
							<label
								className="supt-gdprCategory__label"
								htmlFor={`cookie-law-category-checkbox-${cat['id']}`}
							>
								{
									cat['texts']?.[
										isEnabled ? 'disable' : 'enable'
									]
								}
							</label>
							<span className="supt-gdprCategory__status">
								{
									cat['texts']?.[
										isEnabled ? 'enabled' : 'disabled'
									]
								}
							</span>
						</div>
					)}
				</div>
				<div
					className="supt-gdprCategory__content"
					aria-hidden={isCollapsed}
				>
					<div className="supt-gdprCategory__desc">
						{cat['description']}
					</div>
				</div>
			</li>
		);
	}
);
